var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_shift_list_title"),
      pad: "0",
      addBtn: _vm.hasBtn("add-admin-shift"),
      filterable: "",
      exportBtn: _vm.hasBtn("export-admin-shift"),
      importBtn: _vm.hasBtn("import-admin-shift"),
      "import-options": {
        api: "/shift/import/",
        templateUrl:
          "https://assets.essencehr.io/web/ess-business/assets/shift-import-template.xlsx",
        success: function (result) {
          _vm.getList(null, 1, _vm.$tableSetting.perPageSize, function () {
            _vm.$store.dispatch("resetTable", new Date().getTime())
          })
        },
      },
    },
    on: {
      new: _vm.toNew,
      filter: function (val) {
        _vm.filterPageData = val
      },
      export: _vm.onExport,
    },
    scopedSlots: _vm._u([
      {
        key: "top-selection",
        fn: function (ref) {
          var filter = ref.filter
          return [
            _c("Selections2", {
              attrs: { objects: _vm.filterObjects, "small-chip": "" },
              on: {
                filter: function ($event) {
                  filter()
                  _vm.toFilter(1, filter)
                },
                update: function (prop, value, selected) {
                  _vm.$fliterValue(_vm.filterObjects, prop, value, selected)
                },
                reset: function (apply) {
                  _vm.$fliterValue(_vm.filterObjects, null, null)
                  if (apply) {
                    filter()
                    _vm.toFilter(1, filter)
                  }
                },
              },
            }),
          ]
        },
      },
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Tabler", {
              attrs: {
                headers: _vm.headers,
                items: _vm.desserts,
                totalCount: _vm.totalCount,
                height: _vm.$vuetify.breakpoint.height - 275 - 48,
                sortBy: ["startTime"],
                "filter-page-data": _vm.filterPageData,
                showSelect: _vm.showSelect,
              },
              on: {
                change: function (page, perpage, callback, data) {
                  _vm.getList(data, page, perpage, callback)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "top-selection",
                  fn: function () {
                    return undefined
                  },
                  proxy: true,
                },
                {
                  key: "item.color",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        { staticStyle: { "max-width": "20px" } },
                        [
                          _c("svg-icon", {
                            attrs: {
                              size: "24",
                              fill: item.color_code,
                              iconClass: "LabeledColour",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "item.name",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "text--primary table-title",
                          attrs: {
                            title: _vm.$getCommonLangValue(item.shift_name),
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$getCommonLangValue(item.shift_name)) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "table-subtitle text--secondary" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$getCommonLangValue(item.shift_description)
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "item.abbr",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "text--primary table-title" }, [
                        _vm._v(_vm._s(item.shift_abbr)),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.code",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "text--primary table-title" }, [
                        _vm._v(_vm._s(item.shift_code)),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.startTime",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "text--primary table-title" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$timeMachine(item.start_utc_time)) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.endTime",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "text--primary table-title" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$timeMachine(item.end_utc_time)) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.count",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "text--primary table-title" }, [
                        _vm._v(
                          " " +
                            _vm._s(item.total_working_minutes) +
                            _vm._s(_vm.$t("label_essweb_system_minutesLabel")) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.action",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("tableListTools", {
                        attrs: {
                          uuid: item.uuid,
                          delBtn: _vm.hasBtn("delete-admin-shift"),
                          viewBtn: _vm.hasBtn("view-admin-shift"),
                          editBtn: _vm.hasBtn("edit-admin-shift"),
                          title: _vm.$t("label_essweb_shift_list_title"),
                        },
                        on: {
                          delete: _vm.toDelete,
                          edit: _vm.toEdit,
                          view: _vm.toEdit,
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }